import { React, useState, useEffect } from "react";

const PopUplotteryResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;


    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let lotteryCards = [];
    let lotteryMarkets = [];
    let lotteryWinner = "";

    if (marketType == 53) {

        lotteryCards = resultData.cards_desc
            ? resultData.cards_desc.split(",")
            : [];

        lotteryMarkets = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
            resultData.cat_rnr3,
        ].filter(Boolean);
        const values = lotteryCards.map(card => card.slice(0, -2));

        const uniqueValues = [...new Set(values)];

        if (uniqueValues.length === 1) {
            lotteryWinner = "Triple";
        } else if (uniqueValues.length === 2) {
            lotteryWinner = "Double";
        } else {
            lotteryWinner = "Single";
        }
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="lottery-virtual" style={{ display: marketType == 53 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                Dealer Cards
                                            </span>
                                        </b>
                                        <div className="player-card" style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ display: "flex", justifyContent: "center", padding: "3px" }}>
                                                    {lotteryCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img src={`/assets/images/cards/${card}.svg`} style={{ width: "100%", maxWidth: "45px", height: "auto" }} />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default PopUplotteryResults;

